import { useDroppable } from '@dnd-kit/core';
import { Box, SxProps } from '@mui/material';
import { PlanningEntityIdentifier, PlanningEntityType } from 'generated';
import { PRIMARY, WHITE } from 'constants/colors';
import { ElementType } from 'react';
import { brightness } from 'utils/misc';

interface DroppableCellProps {
  id: string;
  component?: ElementType<HTMLElement>;
  appointmentGroupingEntityId?: string;
  label?: string;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
  scheduleStart: string;
  sx?: SxProps;
}

export default function DroppableCell({
  id,
  component,
  label,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier,
  scheduleStart,
  sx
}: DroppableCellProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      planningEntityType,
      planningEntityId,
      planningEntityIdentifier,
      scheduleStart,
      isDroppableCell: true
    }
  });

  const bgColorStyle = 'rgba(255, 255, 255, 0.75)';

  return (
    <Box
      component={component || 'div'}
      ref={setNodeRef}
      className="cell-droppable-container"
      height="100%"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        className="cell-droppable"
        sx={{
          boxSizing: 'border-box',
          width: '100%',
          height: '100%',
          minHeight: '30px',
          padding: '10px 0',
          color: isOver ? PRIMARY : '#6b6b6b',
          fontSize: '10px',
          fontFamily: 'SourceSansPro-Regular',
          backgroundColor: isOver ? brightness(PRIMARY, 90) : WHITE,
          borderRadius: '4px',
          border: `2px solid ${isOver ? PRIMARY : bgColorStyle}`,
          transition: 'border-color 0.2s ease-in-out',
          ...(sx && sx)
        }}
      >
        {label ?? ''}
      </Box>
    </Box>
  );
}
